import React from 'react'
import CompareTemplate from 'src/components/template/compare'
import { verizonFiosData } from 'src/components/template/compare/components/data/fiosData'

export default (props) => <CompareTemplate location={props.location} data={verizonFiosData} />
